import { render, staticRenderFns } from "./DbpyExD_Export.vue?vue&type=template&id=5488d562"
import script from "./DbpyExD_Export.vue?vue&type=script&lang=js"
export * from "./DbpyExD_Export.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports